export default __webpack_public_path__ + "static/characters-black-39a58305ab08b80df304566d3b41e0d3.png";